import * as React from 'react';

import { SelectInputProps } from '@Components/forms/inputs/SelectInput';
import SelectFilter from '@Components/Page/SelectFilter';
import { OptionItem } from '@Components/Select';
import { Messages } from '@Config/messages';
import { useTranslations } from '@Hooks/useTranslations';
import { desc } from '@Utils/convertions';

import styles from './AdvertSortSelect.module.scss';

interface AdvertsSortSelectProps {
  value?: OptionItem['value'];
  onChange: SelectInputProps['input']['onChange'];
}

export enum AdSortNames {
  avgRating = 'avg_rating',
  createdAt = 'created_at',
  id = 'id',
  status = 'status',
  title = 'title',
  description = 'description',
  location = 'location',
  price = 'price',
  slug = 'slug',
}

const options: OptionItem[] = [
  { value: AdSortNames.title, label: Messages.adSortByTitle },
  { value: desc(AdSortNames.title), label: Messages.adSortByTitleDesc },
  { value: desc(AdSortNames.createdAt), label: Messages.adSorByNewest },
  { value: AdSortNames.price, label: Messages.adSorBytLowestPrice },
  { value: desc(AdSortNames.price), label: Messages.adSorBytHighestPrice },
  { value: desc(AdSortNames.avgRating), label: Messages.adSorByHighestRating },
];

const AdvertsSortSelect: React.FunctionComponent<AdvertsSortSelectProps> = ({
  value = desc(AdSortNames.createdAt),
  onChange,
}) => {
  const t = useTranslations();

  return (
    <SelectFilter
      onChange={onChange}
      options={options}
      filterLabel={t(Messages.adsSortBy)}
      filterValueLabel={Messages.adSorByNewest}
      defaultValue={value}
      size="flex"
      smallerSelect
      className={styles.sortSelect}
    />
  );
};

export default AdvertsSortSelect;
